import React from 'react';
import './App.css';
import {Routes, Route } from 'react-router-dom';
import Gridlayout from './gridlayout';
import PlayerEntry from './playerentry';
import About from './about';
import Contact from './contactus';
import Register from './registeruser';
import { RequireAuth } from 'react-auth-kit';
import Login from './login';
import AuthGrid from './authgrid';
import LiveDisplay from './liveDisplay';

const App = () => {
  
  
  return (
    <div>
       <div>
        <Routes>
          <Route path="/" element={<Gridlayout/>}/>
          <Route path='/login' element={<Login/>}/>
          <Route path="/about" element={<About/>}/>
          <Route path="/contactus" element={<Contact/>}/>
          <Route path="/display" element={<LiveDisplay/>}/>

          <Route path='/authgrid' element={<RequireAuth loginPath={'/login'}>
              <AuthGrid/>
          </RequireAuth>
          }/>
          <Route path="/registeruser" element={<RequireAuth loginPath={'/login'} >
            <Register/>
          </RequireAuth>}/>
          <Route path='/playerentry' element={<RequireAuth loginPath={'/login'}> 
            <PlayerEntry/>
          </RequireAuth>}/>
        </Routes>
        </div> 
    </div>
  );
};

export default App;